import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModuleService, ModulesSubjectService } from '@poliblend/polifunzione-lib';
import { Area } from '@poliblend/polifunzione-lib/lib/_models/area';
import { Microservice } from '@poliblend/polifunzione-lib/lib/_models/microservice';
import { Module } from '@poliblend/polifunzione-lib/lib/_models/module';
import { Role } from '@poliblend/polifunzione-lib/lib/_models/role';
import { Submodule } from '@poliblend/polifunzione-lib/lib/_models/submodule';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, catchError, lastValueFrom, map, Observable, of, Subject, take } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(
    private router: Router,
    private logger: NGXLogger,
    private modulesSubjectService: ModulesSubjectService,
    private moduleService: ModuleService
  ) {}

  login: boolean = false;
  minAuthMicroservice: any;
  typeAlert = '';
  alertText = '';
  alertCount = 0;
  loginLevel: any;
  token: any;
  responseObject: any;
  aree: Area[] = [];
  microservices: Microservice[] = [];
  name: any;
  surname: any;
  permessi: any;
  selectedRole: Role | null = null;
  modulesSubject: Subject<Module[]> = new BehaviorSubject<Module[]>([]);
  modules$: Observable<Module[]> = this.modulesSubject.asObservable();

  ngOnInit(): void {
    this.logger.info('(HOME)ngOnInit');
    this.logger.info(
      "(AUTHENTICATOR-HOME)1 - Verifico che l'utente non abbia già effettuato l'accesso tramite 'loginLevel' e la presenza del token"
    );

    if (
      sessionStorage.getItem('token')
    ) {
      this.name = sessionStorage.getItem('name');
      this.surname = sessionStorage.getItem('surname');
      this.logger.info(
        "(AUTHENTICATOR-HOME)1.1 - L'utente HA effettuato l'accesso, rimane sulla pagina"
      );
      this.login = true;
      if(sessionStorage.getItem('loginLevel')){
        if (sessionStorage.getItem('loginLevel') == 'ldap') {
          this.loginLevel = 2;
        } else if (sessionStorage.getItem('loginLevel') == 'spid') {
          this.loginLevel = 3;
        } else {
          this.loginLevel = 1;
        }
      }
      this.token = sessionStorage.getItem('token');
    } else {
      this.logger.info(
        "(AUTHENTICATOR-HOME)1.1 L'utente NON HA effettuato l'accesso, viene reindirizzato alla home"
      );
      this.router.navigate(['/']);
    }

    if(sessionStorage.getItem('selectedRole')){
      const selectedRoleStr = sessionStorage.getItem('selectedRole');
      this.selectedRole = JSON.parse(selectedRoleStr ? selectedRoleStr: '');

      if(this.selectedRole)
        this.selectRole(this.selectedRole);
    }
  }

  async selectRole(role: Role): Promise<void> {
    this.selectedRole = role;
    sessionStorage.setItem('selectedRole', JSON.stringify(role));

    try {
      // Aspetta che la chiamata per ottenere i moduli sia completata prima di proseguire
      await this.getModules(role);
      this.modulesSubjectService.modules$.pipe(take(1)).subscribe((modules) => {
        // Assegna i moduli all'observable del componente
        if (modules) {
          this.modulesSubject.next(modules); // Aggiorna il BehaviorSubject locale con i moduli ricevuti
        }
      });

    } catch (error) {
      console.error('Errore ricezione moduli', error);
    }

    if (environment.isLocal) {
      window.location.reload();
    } else {
      // Aspetta che i moduli siano effettivamente disponibili prima di chiamare goTo()
      this.modules$.pipe(take(1)).subscribe(modules => {
        if (modules && modules.length > 0) {
          console.log('dentro all if HEADER - MODULI');
          this.goTo(modules[0]);  // Passa il primo modulo dall'osservabile
        } else {
          console.log('fuori dall if HEADER - MODULI');
        }
      });
    }
  }

  goTo(modulo: Module, sottomodulo?: Submodule) {
    if (sottomodulo) {
      window.location.replace(
        environment.baseUrl + modulo.url + '/' + sottomodulo.url
      );
    } else {
        window.location.replace(environment.baseUrl + modulo.url);
    }
  }

  getModules(role: Role): Promise<void | null> {
    return lastValueFrom(
      this.moduleService.getModules(role.name).pipe(
        take(1),  // Prendi solo la prima emissione per evitare esecuzioni ripetute
        map((response) => {
          const modules = response.body.data;
          sessionStorage.setItem('modules', JSON.stringify(modules));
          this.modulesSubjectService.setModules(modules);
        }),
        catchError((err) => {
          console.error('Errore nella ricezione dei moduli', err);
          return of(null); // Ritorna un observable per completare correttamente lo stream
        })
      )
    );
  }

  authVerify(microservice: any): void {
    this.logger.info(
      "(AUTHENTICATOR-HOME)3 - Controllo se l'utente HA i requisiti per l'accesso all'area"
    );
    if (microservice.minLevAuth == 'ldap') {
      this.minAuthMicroservice = 2;
    } else if (microservice.minLevAuth == 'spid') {
      this.minAuthMicroservice = 3;
    } else if (microservice.minLevAuth == 'normal') {
      this.minAuthMicroservice = 1;
    } else {
      console.log('minAuth diverso da spid, ldap o normal, problema !');
    }

    // Se il microservizio selezionato è GestioneAccessi e l'utente è admin di almeno un'area può entrare nell'area.
    if (
      sessionStorage.getItem('listaRuoli')?.includes('Admin') &&
      microservice.tag == 'GestioneAccessi'
    ) {
      this.logger.info(
        "(AUTHENTICATOR-HOME) 3.1 - L'utente è admin di almeno un'area, ha accesso al portale amministrazione."
      );
      window.location.replace(environment.baseUrl + microservice.link);
    } else {
      if (this.loginLevel >= this.minAuthMicroservice) {
        this.logger.info(
          "(AUTHENTICATOR-HOME)3.1 - L'utente HA i requisiti per accedere all'area, reindirizzamento all'area"
        );
        if (
          sessionStorage
            .getItem('listaRuoli')
            ?.includes(microservice.tag + '_User_Read') ||
          sessionStorage
            .getItem('listaRuoli')
            ?.includes(microservice.tag + '_User_Write')
        ) {
          this.logger.info(
            "(AUTHENTICATOR-HOME) X.1 - L'utente HA accesso al microservizio, reindirizzo"
          );
          window.location.replace(environment.baseUrl + microservice.link);
        } else {
          this.logger.warn(
            "(AUTHENTICATOR-HOME) X.1 - L'utente NON HA accesso al microservizio, attivo l'allert"
          );
        }
      } else {
        this.logger.warn(
          "(AUTHENTICATOR-HOME)3.1 - L'utente NON HA i requisiti per accedere all'area, attivo l'alert"
        );
        if (this.minAuthMicroservice == 3) {
        } else if (this.minAuthMicroservice == 2) {
        }
      }
    }
  }

  autenticazione(loginLevelSelected: number): void {
    if (loginLevelSelected == 3) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso SPID"
      );
      window.location.replace(environment.baseUrl + 'spid-authenticator/login');
    } else if (loginLevelSelected == 2) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso LDAP"
      );
      sessionStorage.setItem('loginLevel', 'ldap');
      this.router.navigate(['/login-form']);
    } else if (loginLevelSelected == 1) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso con Email e Pasword"
      );
      sessionStorage.setItem('loginLevel', 'normal');
      this.router.navigate(['/login-form']);
    }
  }
}
